import { literal } from 'zod';

import { BaseChallengeSchema } from './base-challenge.schema';

// Schema for the initial form state before a `challengeType` is selected.
export const DraftChallengeSchema = BaseChallengeSchema.extend({
  challengeType: literal(null),
});
